import { createLazyFileRoute } from '@tanstack/react-router';
import React from 'react';

export const Route = createLazyFileRoute('/not_found/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Page not found...</div>;
}
